import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BatchChangeShopStatusModal from '../molecules/BatchChangeShopStatusModal';
import {
  editGroupShopStatus,
  EDIT_GROUP_SHOP_STATUS_SUCCESS
} from '../../actions/Groups';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          editGroupShopStatus
        },
        dispatch
      )
    })
  ),
  withState('openChange', 'updateOpenChange', false)
);

const button = enhance(
  ({ openChange, disabled, updateOpenChange, processV2, groupId, actions }) => {
    const updateChange = () => {
      updateOpenChange(true);
    };

    const updateShopStatus = async newStatus => {
      processV2.updateOpenProgressV2(true);
      processV2.updateLoadingV2(true);
      const params = {
        status: newStatus,
        processForAllShop: 1,
        shopIds: []
      };

      await actions.editGroupShopStatus(groupId, params).then(async data => {
        if (data.type === EDIT_GROUP_SHOP_STATUS_SUCCESS) {
          updateOpenChange(false);
          processV2.updateOpenProgressV2(true);
          processV2.setResultMessage('設定更新を完了しました。');
          processV2.updateLoadingV2(false);
        } else {
          processV2.setResultMessage('エラーが発生しました。');
          processV2.updateOpenProgressV2(true);
          processV2.updateLoadingV2(false);
        }
      });
    };

    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          一括開店状況変更
        </Button>
        <BatchChangeShopStatusModal
          open={openChange}
          onClose={() => {
            updateOpenChange(false);
          }}
          updateShopStatus={updateShopStatus}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
